import React from 'react';
import shortid from 'shortid';
import classnames from 'classnames';
import { ButtonBase, makeStyles } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import TableRow from '../TableRow';
import './TableHead.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.secondary.main,
  },
}));

const TableHead = ({
  cells = [],
  className = '',
  sortByFields = [],
  onChangeSorting,
  sortOrder = 0,
  sortByField,
}) => {
  const styles = useStyles();
  const classes = classnames('TableHead', className, styles.root);

  const handleChangeSorting = (cell) => () => {
    if (cell !== sortByField) {
      onChangeSorting(cell, sortOrder || 1)();
    } else {
      onChangeSorting(sortOrder === 2 ? '' : cell, sortOrder >= 2 ? 0 : sortOrder + 1)();
    }
  };

  return (
    <TableRow className={classes}>
      {cells.map((cell) => {
        const id = shortid.generate();
        const canSort = sortByFields.includes(cell);
        return (
          <th key={id} className="TableHead__header">
            {canSort ? (
              <ButtonBase onClick={handleChangeSorting(cell)} className="header__button">
                <span className="header__content">{cell}</span>
                {sortByField === cell && (
                  <>
                    {canSort && sortOrder === 2 && <ExpandLess />}
                    {canSort && sortOrder === 1 && <ExpandMore />}
                  </>
                )}
              </ButtonBase>
            ) : (
              <span>{cell}</span>
            )}
          </th>
        );
      })}
    </TableRow>
  );
};

export default TableHead;
